import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { getCustomerServiceTicketsUnreadCountSvc } from '../../../services/retailer';

interface UnreadCountState {
  unreadCount: number;
  isLoadingUnreadCount: boolean;
  unreadCountError: string | null;
}

interface UnreadCountActions {
  fetchUnreadCount: (from?: string, to?: string) => Promise<void>;
  updateUnreadCount: (count: number) => void;
}

type UnreadCountStore = UnreadCountState & UnreadCountActions;

const useUnreadCountStore = create<UnreadCountStore>()(
  devtools(
    (set, get) => ({
      // Initial state
      unreadCount: 0,
      isLoadingUnreadCount: false,
      unreadCountError: null,

      // Actions
      fetchUnreadCount: async (from?: string, to?: string) => {
        set({ isLoadingUnreadCount: true, unreadCountError: null });

        try {
          const unreadCount = await getCustomerServiceTicketsUnreadCountSvc(
            from,
            to
          );
          set({
            unreadCount: unreadCount.count,
            isLoadingUnreadCount: false,
            unreadCountError: unreadCount.error
          });
        } catch (error) {
          console.error('Error fetching unread count:', error);
          set({
            unreadCountError:
              error instanceof Error
                ? error.message
                : 'Failed to fetch unread count',
            isLoadingUnreadCount: false
          });
        }
      },

      updateUnreadCount: (count: number) => {
        set({ unreadCount: count });
      }
    }),
    {
      name: 'unreadCountStore',
      store: 'unreadCountStore'
    }
  )
);

export default useUnreadCountStore;
